import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { MultiValuedListMore } from '../../MultiValuedList'
import { TASK_TYPE_MORE_ITEMS_DROPDOWN_STYLES } from '../Task.constants'
import { TaskTypeListMoreButton } from '../TaskTypeListMoreButton'

function TaskTypeListMore({ activeItem, children, disabled, items }) {
  const isMoreItemActive =
    activeItem && items.find(item => item.id === activeItem.id)

  const curItem = isMoreItemActive ? activeItem : items[0]

  const buttonProps = {
    activeItem,
    icon: curItem.icon,
    id: curItem.id,
  }

  return (
    <MultiValuedListMore
      Button={TaskTypeListMoreButton}
      buttonProps={buttonProps}
      disabled={disabled}
      dropdownPlacement={FLOATING_ELEMENT_PLACEMENT.bottomEnd}
      dropdownStyles={TASK_TYPE_MORE_ITEMS_DROPDOWN_STYLES}
    >
      {children}
    </MultiValuedListMore>
  )
}

export default TaskTypeListMore
